import { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';

@Component({
  selector: 'pdv-change-login-form',
  templateUrl: './change-login-form.component.html',
  styleUrls: ['./change-login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiChangeLoginFormComponent implements OnInit {
  @Output() submitForm = new EventEmitter();

  formGroupChange!: FormGroup<{
    login: FormControl<string | null>;
    password: FormControl<string | null>;
    newLogin: FormControl<string | null>;
    newPassword: FormControl<string | null>;
  }>;

  ngOnInit(){
    this.formGroupChange = new FormGroup({
      login: new FormControl<string>('', [Validators.required]),
      password: new FormControl<string>('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      newLogin: new FormControl<string | null>(null),
      newPassword: new FormControl<string | null>(null, [
        Validators.required,
        Validators.minLength(6),
      ])
    });
    this.formGroupChange.valueChanges.forEach((value) => {
      const transformedValue = {
        login: value.login?.toUpperCase() ?? null,
        password: value.password?.toUpperCase() ?? null,
        newLogin: value.newLogin?.toUpperCase() ?? null,
        newPassword: value.newPassword?.toUpperCase() ?? null,
      };

      this.formGroupChange.patchValue(transformedValue, { emitEvent: false });
    });
  }
}
